<template>
  <footer class="footer px-4 bg-transparent">
    <div class="row align-items-center justify-content-lg-between">
      <div class="col-lg-6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}}
          <a
            href="https://canplast.net"
            class="font-weight-bold ml-1"
            target="_blank"
            style="color:#525f7f"
          >Canplast México S de RL de CV</a>
        </div>
      </div>
      <div class="col-lg-6">
        <ul class="nav nav-footer justify-content-center justify-content-lg-end">
          <li class="nav-item">
            <a href="https://www.canplast.com.mx" style="background-color: transparent; border: none;" class="nav-link" target="_blank">canplast.com.mx</a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
